export enum notificationType {
  BUG_FIX = 'bug_fix',
}

export const lastReleaseDateKey = 'lastReleaseDate'

export const notificationIntervals: { [key: string]: number } = {
  halfAnHour: 30 * 60 * 1000,
  oneHour: 60 * 60 * 1000,
  twoMinutes: 2 * 60 * 1000,
  initialInterval: 60 * 60 * 1000,
  releaseCheckInterval: 7 * 24 * 60 * 60 * 1000,
}
